import React, { lazy } from 'react';
import { PicksView } from '@shared/ui/picks/PicksView';
import { Versioned } from '@shared/ui/uiVersion';
import { MainLayout } from '../layouts';

// Loaded only when shown, so its global CSS never reaches the new look
const ClassicHighProbabilityPage = lazy(() => import('./classic/HighProbabilityPage'));

/** High-probability page: classic, or the shared view in this app's frame (ADR-0008). */
const HighProbabilityPage: React.FC = () => (
  <Versioned classic={<ClassicHighProbabilityPage />}>
    <MainLayout>
      <PicksView />
    </MainLayout>
  </Versioned>
);

export default HighProbabilityPage;
